/**
 * Etiquetas en español para `crm_calls.call_status` (valores del proveedor en inglés).
 */

const LABELS: Record<string, string> = {
  initiated: 'Iniciada',
  ringing: 'Timbrando',
  answered: 'Contestada',
  ended: 'Finalizada',
  no_answer: 'Sin respuesta',
  failed: 'Fallida',
  busy: 'Ocupado',
  cancelled: 'Cancelada',
  canceled: 'Cancelada',
};

export function crmCallStatusLabelEs(status: string | null | undefined): string {
  if (status == null || String(status).trim() === '') return '—';
  const key = status.trim().toLowerCase();
  return LABELS[key] ?? status;
}
